import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "sv_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = useCallback((product, size, quantity = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id && i.size === size);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + quantity };
        return next;
      }
      return [...prev, {
        product_id: product.id, slug: product.slug, title: product.title,
        price: product.price, image: product.images?.[0] || "", size, quantity,
      }];
    });
    setOpen(true);
  }, []);

  const setQty = (product_id, size, quantity) =>
    setItems((prev) => prev.map((i) => (i.product_id === product_id && i.size === size ? { ...i, quantity: Math.max(1, quantity) } : i)));

  const removeItem = (product_id, size) =>
    setItems((prev) => prev.filter((i) => !(i.product_id === product_id && i.size === size)));

  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, open, setOpen, addItem, setQty, removeItem, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}
